import styled from 'styled-components';

export const SectionFZTextImage = styled.div`
  display: flex;
  padding: 0;

  @media (max-width: 575.98px) {
    flex-flow: column;
  }
`;

export const BoxOne = styled.div`
  &.grey {
    background-color: #ebebeb;
    opacity: 1;
  }

  display: flex;
  padding: 10vh 0;
  width: 50%;

  @media (min-width: 993px) and (max-width: 1100px) {
    padding: 10vh 15px;
  }

  @media (max-width: 991.98px) {
    padding: 50px 30px;
    width: 50%;
  }

  @media (max-width: 767.98px) {
    width: 50%;
    padding: 50px;
  }

  @media (max-width: 575.98px) {
    width: 100%;
    padding: 50px;
  }
`;

export const FZArticle = styled.div`
  max-width: 375px;
  margin: 0 auto;
  position: relative;
  z-index: 2;

  @media (max-width: 767.98px) {
    max-width: inherit;
  }
`;

export const FZArticleDiv = styled.div`
  padding-bottom: 15px;
`;

export const BoxTwo = styled.div`
  width: 50%;

  .lazy-load-image-background {
    display: block !important;
    width: 100%;
    height: 100%;
  }

  @media (max-width: 991.98px) {
    width: 50%;
  }

  @media (max-width: 575.98px) {
    width: 100%;
  }

  img {
    min-height: 300px;
    background-color: #f7f7f7;
    height: 100%;
    object-fit: cover;
    width: 100%;
  }
`;
